<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="copyright"></a><a id="page_iv"></a>NEW YORK UNIVERSITY PRESS<br/>New York and London<br/><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></p>
<p class="copyright1">© 2006 by New York University<br/>All rights reserved</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data<br/>Baum, Bruce David, 1960–<br/>The rise and fall of the Caucasian race :<br/>a political history of racial identity / Bruce Baum.<br/>p. cm.<br/>Includes bibliographical references and index.<br/>ISBN–13: 978–0–8147–9892–8 (cloth : alk. paper)<br/>ISBN–10: 0–8147–9892–6 (cloth : alk. paper)<br/>1. Caucasian race—History. 2. Race awareness—Political aspects.<br/>3. Whites—Race identity. I. Title.<br/>HT1575.B385      2006<br/>305.809′073—dc22                  2005024718</p>
<p class="copyright1">New York University Press books are printed on acid-free paper,<br/>and their binding materials are chosen for strength and durability.</p>
<p class="copyright1">Manufactured in the United States of America<br/>c 10 9 8 7 6 5 4 3 2 1<br/>p 10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?123e64e0